export default function PHP_array_sum() {
  return (
    <div>
      <h1>PHP_array_sum</h1>
    </div>
  );
}
